<template>
  <div class="navigate-up ma-0 pa-0 full-width">
    <div class="d-flex align-center ml-0 row-height" v-if="path.length > 0">
      <div class="d-flex pl-4 full-width">
        <v-icon icon class="pr-4" @click="$emit('oneLevelBack')">mdi-arrow-up-bold</v-icon>
        <div class="align-self-center" @click="$emit('oneLevelBack')">{{ breadcrumb }}</div>
        <v-spacer></v-spacer>
        <v-btn v-if="showFilter" icon x-small @click="toggleFilter()" class="align-self-center mr-7">
          <morph-icon :color="darkMode ? 'white' : ''" to-icon="mdi-close" :from-icon="filterIcon" :trigger="isFilterVisible"></morph-icon>
        </v-btn>
      </div>
    </div>
    <!-- <div class="d-flex align-center ml-0 row-height" v-else-if="!isFilterVisible && this.path.length === 0" @click="$router.push('/')"> -->
    <div class="d-flex align-center ml-0 row-height" v-else-if="path.length === 0">
      <div class="d-flex pl-4 full-width">
        <div class="align-self-center">{{ rootText }}</div>
        <v-spacer></v-spacer>
        <v-btn v-if="showFilter" icon x-small @click="toggleFilter()" class="align-self-center mr-7">
          <morph-icon :color="darkMode ? 'white' : ''" to-icon="mdi-close" :from-icon="filterIcon" :trigger="isFilterVisible"></morph-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@/mixins/common';
import MorphIcon from '../icons/MorphIcon.vue';

export default {
  props: {
    showFilter: Boolean,
    isFilterVisible: Boolean,
    isFilterActive: Boolean,
    path: Array,
    breadcrumb: String,
    rootTextKey: String, // the text key to be used when the navigateUp component is displayed within the root of a tree
  },
  components: {
    MorphIcon,
  },
  emits: ['toggleFilter'],
  mixins: [common],
  computed: {
    rootText() {
      return this.$t(this.rootTextKey);
    },
    filterIcon() {
      return this.isFilterActive ? 'mdi-filter-check' : 'mdi-filter';
    },
  },
  methods: {
    toggleFilter() {
      this.$emit('toggleFilter');
    },
  },
};
</script>

<style scoped>
.row-height {
  height: 43px;
}
.theme--dark .navigate-up {
  background: #202020;
}
.theme--light .navigate-up {
  background: #f9f9fa;
}
</style>
